import React from "react";

const SvgArrowLeft = ({ color, ...props }) => (
  <svg viewBox="0 0 12 8" width="12" {...props}>
    <defs>
      <path
        id="a"
        d="M506.001 217.07h-6.294V215L494 219l5.708 4v-2.07h6.294z"
      />
      <clipPath id="b">
        <use fill="#fff" xlinkHref="#a" />
      </clipPath>
    </defs>
    <g transform="translate(-494 -215)" fill="#fff">
      <use xlinkHref="#a" />
      <use
        fillOpacity={0}
        stroke={color}
        strokeMiterlimit={50}
        strokeWidth={0.54}
        clipPath="url(#b)"
        xlinkHref="#a"
      />
    </g>
  </svg>
);

export default SvgArrowLeft;
